import { createServerFn } from '@tanstack/react-start'
import { generateSlugWithDate } from '../shared/crudFactory'
import { putToS3 } from '../../lib/s3'
import { createNoteSchema } from './noteSchemas'
import type { Note } from './noteSchemas'

export const createNote = createServerFn({ method: 'POST' })
  .inputValidator(createNoteSchema)
  .handler(async (ctx): Promise<{ success: boolean; id: string }> => {
    const { title, segments, lastEditedBy } = ctx.data
    const now = new Date().toISOString()
    const note: Note = {
      id: generateSlugWithDate(title || 'untitled'),
      title: title.trim() || 'Untitled',
      segments,
      lastEditedBy,
      createdAt: now,
      updatedAt: now,
    }
    await putToS3(`notes/${note.id}.json`, note)
    return { success: true, id: note.id }
  })
